import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";
import { FiCheckCircle } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const LegalRepresentation = () => {
    const { t } = useTranslation();
    const description = t("service_pages.legal_representation.description");
    const features = t("service_pages.legal_representation.features", { returnObjects: true });
    const highlights = t("service_pages.legal_representation.highlights", { returnObjects: true });
    const steps = t("service_pages.legal_representation.steps", { returnObjects: true });
    const faqs = t("service_pages.legal_representation.faqs", { returnObjects: true });

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Immigration Legal Representation",
        description,
        provider: {
            "@type": "LocalBusiness",
            name: "Citizen Hub Immigration Services",
            telephone: "+1 3108802133",
            email: "info@citznhub.com",
        },
        areaServed: [
            "United States",
            "California",
            "New York",
            "Texas",
            "Florida",
        ],
    };

    // Create a simple icon-based image placeholder
    const IconPlaceholder = () => (
        <div className="w-full h-96 lg:h-[28rem] bg-gradient-to-br from-indigo-500 to-blue-600 rounded-2xl shadow-lg flex items-center justify-center">
            <FiCheckCircle className="w-48 h-48 text-white opacity-80" />
        </div>
    );

    return (
        <ServiceDetailLayout
            title={t("service_pages.legal_representation.title")}
            subtitle={t("service_pages.legal_representation.subtitle")}
            description={description}
            features={features}
            highlights={highlights}
            steps={steps}
            faqs={faqs}
            imageSrc={null}
            imageAlt="Immigration legal representation"
            canonicalUrl="https://citizenhubimmigration.com/services/legal-representation"
            structuredData={structuredData}
            customImage={<IconPlaceholder />}
        />
    );
};

export default LegalRepresentation;
